<template>
  <VCol
    v-bind="$props"
    class="w-col"
  >
    <slot />
  </VCol>
</template>

<script>
import { VCol } from 'vuetify/lib';

export default {
  props: {
    ...VCol.options.props,
  },
  components: { VCol },
};
</script>
